export function isInternalMenuUrl(url) {
  return typeof url === 'string' && url.startsWith('/') && !url.startsWith('//')
}
